<template>
    <div class="bg-dark" style="width: 100%;height:100%;opacity: 0;transition: opacity 1s">
        <div v-if="small">
            <div style="padding:6px">
                <cover-card :image="coverImage" :quote="d.quote" :text="d.brief" style="margin:auto;margin-top:6px"></cover-card>

                <div style="box-sizing: border-box; margin:auto;margin-top:6px;width:100%;max-width: 600px"
                     v-for="(p,index) in projects">
                    <arrow-card style="width:100%;max-width: 600px;margin-bottom:6px"
                                :direction="index%2===0?'right':'left'" :name="p.name" :title="p.title"
                                :subtitle="p.subtitle" :details="p.details"
                                :web = "p.web"
                                :thumb="url(p.id,p.thumb)"
                                :photo="url(p.id,p.photo)"></arrow-card>
                </div>
            </div>

        </div>
        <div v-if="!small">
            <table  class="main-display-width" cellpadding="0" cellspacing="6">
                <tr>
                    <td valign="top" width="50%">

                        <cover-card :image="coverImage" :quote="d.quote" :text="d.brief" style="margin-top:6px"></cover-card>

                        <div v-for="(p,index) in odd">
                            <arrow-card style="width:100%;max-width: 600px;margin-top:6px;"
                                        :direction="index%2===0?'right':'left'" :name="p.name"
                                        :title="p.title" :subtitle="p.subtitle" :details="p.details"
                                        :web = "p.web"
                                        :thumb="url(p.id,p.thumb)"
                                        :photo="url(p.id,p.photo)"></arrow-card>
                        </div>
                    </td>
                    <td valign="top" width="50%">
                        <div v-for="(p,index) in even">
                            <arrow-card style="width:100%;max-width: 600px;margin-top:6px;"
                                        :direction="index%2!==0?'right':'left'" :name="p.name"
                                        :title="p.title" :subtitle="p.subtitle" :details="p.details"
                                        :web = "p.web"
                                        :thumb="url(p.id,p.thumb)"
                                        :photo="url(p.id,p.photo)"></arrow-card>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <contact-card style="padding:6px;padding-top: 0px"></contact-card>
        <foot></foot>
    </div>
</template>

<script>
	import ArrowCard from "@/components/ArrowCard";
	import axios from 'axios';
	import Foot from "@/components/Foot";
	import ContactCard from "@/components/ContactCard";
	import CoverCard from "@/components/CoverCard";

	export default {
		name: "Projects",
		props: {
			baseURL: String
		},
		data() {
			return {
				d: {},
				projects:null,
				odd: [],
				even: [],
				coverImage:null
			}
		},
		components: {
			Foot,
			ArrowCard,
			ContactCard,
            CoverCard
		},
		methods: {
			url(id,p){
				return this.baseURL+"projects/"+id+"/"+p;
            }
        },
		computed: {
			small() {
				return this.$mq === 'sm';
			}
		},
		mounted() {
			// console.log(this.baseURL+'/about/' + 'conf.json');
			setTimeout(() => {
				this.$el.style.opacity = '1'
			}, 10);
			axios
				.get(this.baseURL + 'projects/' + 'conf.json',{
					headers: {
						Accept: "application/json",
						"Content-Type": "application/json"
					},
					method: "POST",
					mode: "cors"
				})
				.then(response => {
					// console.log(response.data);
					this.d = response.data;
					this.coverImage=this.baseURL+"projects/"+this.d.cover;
					this.projects=response.data.projects;
					for (let i = 0; i < this.projects.length; i++) {
						if (i % 2 === 0) {
							this.even.push(this.projects[i]);
						} else {
							this.odd.push(this.projects[i]);
						}
					}
				});
		}
	}
</script>

<style scoped>

</style>